import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import { appRoute } from 'app/railways/router/routes';

import { TTerminalProfile } from '../../core/profiles';

export const cols: TEntityGridColumn<TTerminalProfile>[] = [
  {
    field: 'id',
    headerName: 'ID',
    width: 50,
    flex: 1,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTerminalProfile }) => {
      const path = appRoute.PROFILE.buildPath({ id: data.id });

      return <Link to={path}>{data.id}</Link>;
    },
  },
  {
    flex: 3,
    field: 'name',
    headerName: 'Название',
    colId: 'name',
    sortable: false,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTerminalProfile }) => {
      const path = appRoute.PROFILE.buildPath({ id: data.id });

      return <Link to={path}>{data.name}</Link>;
    },
  },
  {
    flex: 3,
    field: 'employees',
    headerName: 'Cотрудники',
    colId: 'employees',
    sortable: false,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTerminalProfile }) => {
      return `${data.employees.length} шт.`;
    },
  },
];
